import { render } from "./topChart.vue?vue&type=template&id=0c9e967c"
import script from "./topChart.vue?vue&type=script&lang=js"
export * from "./topChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__